module.exports = __webpack_public_path__ + "static/media/noImage.f7f7e84a.png";